// 업무/기능 배정 탭 – WORK_ASSIGNMENT 권한을 보유한 직원 전용
// 본인이 소유한 업무/기능 범위 내에서만 다른 직원에게 배정 가능
// PermissionAssignment 컴포넌트의 isDelegate=true 버전으로 위임
import PermissionAssignment from './PermissionAssignment';

export default function SubWorkAssignment({ onPermissionsChanged }) {
  return <PermissionAssignment isDelegate={true} onPermissionsChanged={onPermissionsChanged} />;
}
